import ReactGA from 'react-ga4'
import config from '~/config'

export function initialize() {
  ReactGA.initialize([
    {
      trackingId: config.GOOGLE_ANALYTICS_TRACKING_ID || '',
      gaOptions: {
        sampleRate: 100,
        siteSpeedSampleRate: 5,
        debug_mode: config.IS_DEVELOPMENT
      },
      gtagOptions: {
        debug_mode: config.IS_DEVELOPMENT,
        send_page_view: true
      }
    }
  ])
}

export function pushDragDropSingleInputEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Single Input')
}

export function pushDragDropCheckboxEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Checkbox')
}

export function pushDragDropRadiogroupEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Radiongroup')
}

export function pushDragDropDropdownEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Dropdown')
}

export function pushDragDropCommentEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Comment')
}

export function pushDragDropBooleanEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Boolean')
}

export function pushDragDropHtmlEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Html')
}

export function pushDragDropMultipleTextEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Multiple Text')
}

export function pushDragDropMatrixEvent() {
  pushEvent('Add New Question', 'Toolbox', 'Matrix')
}

export function pushEditQuestionEvent() {
  pushEvent('Edit', 'Toolbox', 'Edit Question')
}

export function pushMakeRequiredFieldEvent() {
  pushEvent('Edit', 'Toolbox', 'Required Field')
}

export function pushMakeUnrequiredFieldEvent() {
  pushEvent('Edit', 'Toolbox', 'Unrequired Field')
}

export function pushMakeVisibleEvent() {
  pushEvent('Edit', 'Toolbox', 'Visible')
}

export function pushMakeNotVisibleEvent() {
  pushEvent('Edit', 'Toolbox', 'Not Visible')
}

export function pushAddNewPageEvent() {
  pushEvent('Edit', 'Toolbox', 'Add New Page')
}

export function pushSaveEvent() {
  pushEvent('Save', 'Toolbox', 'Save')
}

export function pushExportPDFEvent() {
  pushEvent('Export', 'Toolbox', 'Export PDF')
}

export function pushLoadVersionEvent() {
  pushEvent('Load Version', 'Toolbox', 'Load Version')
}

export function pushExportCustomEnrolmentReportEvent() {
  pushEvent('Export', 'Toolbox', 'Export Custom Enrolment Report')
}

export function pushExportCustomDetailsReportEvent() {
  pushEvent('Export', 'Toolbox', 'Export Custom Details Report')
}

export function pushUndoEvent() {
  pushEvent('Undo', 'Toolbox', 'Undo')
}

export function pushRedoEvent() {
  pushEvent('Redo', 'Toolbox', 'Redo')
}

// Event parameters and information here: https://developers.google.com/analytics/devguides/collection/gtagjs/events
function pushEvent(action, category, eventLabel) {
  ReactGA.event({
    action: action,
    category: category,
    label: eventLabel
  })
}
